export default __webpack_public_path__ + "static/media/logo-sm.da0a6eb1.png";